<template>
  <List :mapState="'restaurantCategories'" :allDispatch="'restauranCategoriesALL'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/categories/list.vue